import React from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Flex, Text, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from '../styles/ToDoListConent.module.scss';
import {ISort} from '../../../stores/Form/Sort';

type ContentHeaderProps = {
    viewCols: priority.netitems.form.IColumn[];
    onSort: (viewCol: priority.netitems.form.IColumn) => void;
    sortedCol: ISort;
};
export const ContentHeader = ({viewCols, onSort, sortedCol}: ContentHeaderProps) => {
    return (
        <div className={styles.headerContainer}>
            <div className={styles.basicInfo} />
            {viewCols.map(viewCol => {
                const isSorted = sortedCol?.ColumnID === viewCol.ID;
                return (
                    <div className={styles.mainColumn} key={viewCol.Name}>
                        <Flex key={viewCol.Name} justifyContent="flex-start" alignItems="center">
                            <Text
                                skin="tiny"
                                textColor="secondary-500"
                                componentClasses={styles.headerTitle}
                            >
                                {viewCol.Title}
                            </Text>
                            <div onClick={() => onSort(viewCol)}>
                                <Flex direction="column">
                                    <Icon
                                        icon={PriorityIcon.arrowDropUp}
                                        iconColor={
                                            isSorted && !sortedCol.Desc
                                                ? 'primary-700'
                                                : 'secondary-200'
                                        }
                                        componentClasses={cx(styles.sortIcon, styles.sortAsc)}
                                    />
                                    <Icon
                                        icon={PriorityIcon.arrowDropDown}
                                        iconColor={
                                            isSorted && sortedCol.Desc
                                                ? 'primary-700'
                                                : 'secondary-200'
                                        }
                                        componentClasses={cx(styles.sortIcon, styles.sortDes)}
                                    />
                                </Flex>
                            </div>
                        </Flex>
                    </div>
                );
            })}
            <div className={styles.listItemBtns} />
        </div>
    );
};
